import { Observable } from 'rxjs';
import { BackendDecorator } from './BackendDecorator';
import Backend, { Headers } from './Backend';
import { AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';

export default (headersToInject: () => Headers): BackendDecorator => (backend: Backend): Backend => ({
    get: (url: string, headers?: {}): Observable<AjaxResponse> => {
        return backend.get(url, {
            ...headersToInject(),
            ...headers
        });
    },
    post: (url: string, body: {}, headers?: {}): Observable<AjaxResponse> => {
        return backend.post(url, body, {
            ...headersToInject(),
            ...headers
        });
    },
    delete: (url: string, headers?: {}): Observable<AjaxResponse> => {
        return backend.delete(url, {
            ...headersToInject(),
            ...headers
        });
    },
    put: (url: string, body: {}, headers?: {}): Observable<AjaxResponse> => {
        return backend.put(url, body, {
            ...headersToInject(),
            ...headers
        });
    }
});



// WEBPACK FOOTER //
// ./src/application/core/backend/decorateWithHeaders.ts